export default __webpack_public_path__ + "static/media/billmgr-hover.eb90be72.svg";